module.exports = __webpack_public_path__ + "static/img/home_img_judian_sj.dd36906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img_judian_sj.png
// module id = M/2w
// module chunks = 11